import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { readSignUpNotifications, setSignUpNotifications } from "../../api/accountNotificationApi";
import ErrorNotice from "../../errors/ErrorNotice";
import { useLoad } from "../../shared/loading/useLoad";
import { useSubmission } from "../../shared/state/useSubmission";
import OptionCard from "../../ui/forms/OptionCard";

const SIGN_UP_EMAILS = ["on", "off"] as const;

/** An administrator's own setting: an email for each new sign-up, as an option card among the
 * Personal preferences (F71). */
export default function SignUpNotifications() {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => readSignUpNotifications(signal), []);
  const { state, reload } = useLoad(load);
  const submission = useSubmission();
  return (
    <>
      {state.status === "loaded" ? (
        <OptionCard
          label={t("profile.signUpEmails.label")}
          title={t("profile.signUpEmails.hint")}
          value={state.value ? "on" : "off"}
          options={SIGN_UP_EMAILS.map((choice) => ({ value: choice, label: t(`profile.signUpEmails.${choice}`) }))}
          disabled={submission.state.status === "submitting"}
          onChange={(choice) => {
            submission.submit(async () => { await setSignUpNotifications(choice === "on"); reload(); });
          }}
        />
      ) : null}
      {state.status === "failed" ? <ErrorNotice error={state.error} onRetry={reload} /> : null}
      {submission.state.status === "failed" ? <ErrorNotice error={submission.state.error} /> : null}
    </>
  );
}
